"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Image: function() {
        return _index.Image;
    },
    imageClassNames: function() {
        return _index.imageClassNames;
    },
    renderImage_unstable: function() {
        return _index.renderImage_unstable;
    },
    useImageStyles_unstable: function() {
        return _index.useImageStyles_unstable;
    },
    useImage_unstable: function() {
        return _index.useImage_unstable;
    }
});
const _index = require("./components/Image/index");
